import api from './api';

const announcementsService = {
  async list(filters = {}) {
    const params = new URLSearchParams();
    if (filters.status) params.set('status', filters.status);
    if (filters.category) params.set('category', filters.category);
    if (filters.pinned) params.set('pinned', 'true');
    const qs = params.toString();
    const response = await api.get(`/partners/announcements${qs ? `?${qs}` : ''}`);
    return response.data;
  },

  async create(data) {
    const response = await api.post('/partners/announcements', data);
    return response.data;
  },

  async update(id, data) {
    const response = await api.put(`/partners/announcements/${id}`, data);
    return response.data;
  },

  async publish(id, publish = true) {
    const response = await api.post(`/partners/announcements/${id}/publish`, { publish });
    return response.data;
  },

  async remove(id) {
    const response = await api.delete(`/partners/announcements/${id}`);
    return response.data;
  }
};

export default announcementsService;
